// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_zonTc","tag":"tag_tOjwR","absolute":"absolute_bVnqb"};